import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Tag as AntdTag, Tooltip } from 'antd';
import Tag from '../../../../shared-components/Tag';
import TagMultipleSelect from '../../../../shared-components/TagMultipleSelect';
import {
  searchForTags,
  addIOCTag,
  removeIOCTag,
  resetTagSearch,
} from '../../../../redux/actions/tags';
import {
  selectFoundTags,
  selectIOCTagsObject,
} from '../../../../redux/selectors/tags';
import styles from './tag-list.module.sass';
import tagStyles from '../../../../shared-components/Tag/tag.module.sass';
import { ReactComponent as three_dots } from '../../../../assets/icons/three_dots.svg';
import Icon from '@ant-design/icons';

export class TagList extends React.Component {
  state = {
    editing: false,
  };

  // handleClickOutside = (e) => {
  //   this.setState({ editing: false });
  // };

  handleContainerClick = () => {
    this.setState({ editing: true });
  };

  handleBlur = () => {
    // this.props.resetTagSearch();
    this.setState({ editing: false });
  };

  handleRemoveClick = (tag) => {
    const { scoreDetails } = this.props;
    // this.props.removeIOCTag(tag, scoreDetails);
    this.props.removeIOCTag(tag?.uuid, scoreDetails?.uuid);
  };

  returnTagStyle = (tag) => {
    if (tag?.is_collected_tag) {
      return 'volcano';
    } else if (tag?.is_feed_tag) {
      return null;
    } else {
      return 'gold';
    }
  };

  render() {
    const { foundTags, searchStatus, scoreDetails } = this.props;
    const { editing } = this.state;
    const collected_tags = scoreDetails?.collected_tags || [];
    const feed_tags = scoreDetails?.feed_tags || [];
    const user_tags = scoreDetails?.user_tags || [];
    let all_tags = scoreDetails?.tags || [];
    all_tags = all_tags?.map((tag) => {
      const is_tag_present = (current_tag) =>
        current_tag['uuid'] === tag['uuid'];
      const is_collected_tag = collected_tags?.some(is_tag_present);
      const is_feed_tag = feed_tags?.some(is_tag_present);
      const is_user_tag = user_tags?.some(is_tag_present);
      return {
        is_collected_tag,
        is_feed_tag,
        is_user_tag,
        ...tag,
      };
    });
    const first_tags = all_tags?.slice(0, 3);
    // (all_tags) - (user_tags[-3])
    const tags_diff_user_tags = all_tags?.filter(
      (t) =>
        !scoreDetails?.user_tags
          ?.slice(-3)
          ?.some((ut) => t?.id === ut?.id?.toString()),
    );
    const first_to_middle_tags = tags_diff_user_tags?.slice(
      0,
      tags_diff_user_tags?.length - 3,
    );
    const middle_to_last_tags = all_tags?.slice(3);

    return (
      <div className={styles.container}>
        <div className="navbar_text">
          <>
            {!editing && // show only first 3 tags when not editing
              first_tags?.map((tag, id) => {
                return (
                  <Tag
                    key={`${tag?.uuid + id}`}
                    tag={tag}
                    canClick={true}
                    canRemove={!tag?.is_collected_tag && !tag?.is_feed_tag}
                    tagColor={this.returnTagStyle(tag)}
                    isTagManuallyCreated={tag?.is_user_tag ? true : false}
                    onClose={() => this.handleRemoveClick(tag)}
                  />
                );
              })}
            {all_tags.length > 3 &&
              (first_to_middle_tags?.length > 0 ||
                middle_to_last_tags?.length > 0) && (
                <Tooltip
                  title={
                    editing // show tooltip within (all_tags)-(user_tags[-3]) from position 0 to -3 when editing
                      ? first_to_middle_tags?.map((tag, id) => {
                          return (
                            <Tag
                              key={`${tag?.uuid + id}`}
                              tag={tag}
                              canRemove={
                                !tag?.is_collected_tag && !tag?.is_feed_tag
                              }
                              canClick={true}
                              isTagManuallyCreated={
                                tag?.is_user_tag ? true : false
                              }
                              tagColor={this.returnTagStyle(tag)}
                              onClose={() => this.handleRemoveClick(tag)}
                            />
                          );
                        }) // show tooltip within all_tags from position 3 to end when not editing
                      : middle_to_last_tags?.map((tag, id) => {
                          return (
                            <Tag
                              key={`${tag?.uuid + id}`}
                              tag={tag}
                              canClick={true}
                              canRemove={
                                !tag?.is_collected_tag && !tag?.is_feed_tag
                              }
                              isTagManuallyCreated={
                                tag?.is_user_tag ? true : false
                              }
                              tagColor={this.returnTagStyle(tag)}
                              onClose={() => this.handleRemoveClick(tag)}
                            />
                          );
                        })
                  }
                >
                  <Icon
                    style={{
                      width: '24px',
                      margin: '5px',
                      fontSize: '24px',
                      transform: 'rotate(-90deg)',
                      verticalAlign: 'middle',
                    }}
                    component={three_dots}
                  />
                </Tooltip>
              )}
          </>
          {editing ? (
            <>
              {scoreDetails?.collected_tags?.slice(-3)?.map((tag, id) => {
                return (
                  <Tag
                    key={`${tag?.uuid + id}`}
                    tag={tag}
                    canClick={true}
                    tagColor={this.returnTagStyle(tag)}
                    isTagManuallyCreated={tag?.is_user_tag ? true : false}
                    onClose={() => this.handleRemoveClick(tag)}
                  />
                );
              })}
              <TagMultipleSelect
                foundTags={foundTags}
                searchStatus={searchStatus}
                searchForTags={this.props.searchForTags}
                scoreDetails={this.props.scoreDetails}
                addIOCTag={this.props.addIOCTag}
                removeIOCTag={this.props.removeIOCTag}
                onBlur={this.handleBlur}
                clearValue
              />
            </>
          ) : (
            <Tooltip title="Add a tag to the observable">
              <AntdTag
                role="button"
                aria-label="addObs"
                className={cx(tagStyles.tag, styles.add_btn)}
                onClick={this.handleContainerClick}
              >
                + Add Tag
              </AntdTag>
            </Tooltip>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  scoreDetails: state.ioc.scoreDetails,
  foundTags: selectFoundTags(state),
  searchStatus: state.tags.searchStatus,
  iocTagsObject: selectIOCTagsObject(state),
});

const mapDispatchToProps = {
  searchForTags,
  addIOCTag,
  removeIOCTag,
  resetTagSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(TagList);
